import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { ButtonComponent } from '@fcom/ui-components/components/buttons/button/button.component';
import { LinkComponent } from '@fcom/ui-components/components/link/link.component';
import { LoaderComponent } from '@fcom/ui-components/components/loader/loader.component';
import { NotificationComponent } from '@fcom/ui-components/components/notifications/notification/notification.component';
import { TextInputComponent } from '@fcom/ui-components/components/forms/text-input/text-input.component';
import { DirectiveModule, FinFormsModule, PipesModule } from '@fcom/common';
import { UiTranslateModule } from '@fcom/ui-translate';
import { ComponentsModule } from '@fcom/common/components/components.module';
import { RefundsCommonModule } from '@fcom/refunds-common';
import { RefundsService } from '@fcom/refunds-common/services/refunds.service';
import { CommonBookingAncillaryService } from '@fcom/common-booking/modules/ancillaries/services/common-booking-ancillary.service';

import { MmbRefundFormComponent } from './mmb-refund-form/mmb-refund-form.component';

@NgModule({
  declarations: [MmbRefundFormComponent],
  exports: [MmbRefundFormComponent],
  imports: [
    CommonModule,
    DirectiveModule,
    PipesModule,
    UiTranslateModule,
    ButtonComponent,
    LinkComponent,
    LoaderComponent,
    NotificationComponent,
    TextInputComponent,
    ComponentsModule,
    FinFormsModule,
    RefundsCommonModule,
    RouterModule,
  ],
  providers: [RefundsService, CommonBookingAncillaryService],
})
export class MmbRefundWidgetModule {}
